import React from 'react'

import styled from 'styled-components'

const Env = styled.div`
  line-height: 1.5;
  white-space: pre-wrap;
  font-family: monospace;
`

const EnvVariables = () => {
  return <Env>{JSON.stringify(process.env, null, 2)}</Env>
}

export default EnvVariables
